import styled, { css } from "styled-components";

import { fadeUpAnimation } from "@sellernote/shipda-kr/src/components/landing/index.styles";
import { COLOR, TEXT_COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const containerWrapper = styled.section`
  display: flex;
  justify-content: center;
  height: 743px;
  background-color: ${COLOR.bgColor_1};

  ${mobile(css`
    height: 942px;
  `)};
`;

const container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0 0 0;

  ${fadeUpAnimation}

  ${mobile(css`
    width: 100%;
    padding: 48px 16px;
    align-items: flex-start;
    height: auto;
  `)};

  > h3 {
    width: 100%;
    ${setFontStyle("Head4")};
    margin-bottom: 24px;
    text-align: center;

    ${mobile(css`
      ${setFontStyle("Head6")};
      margin-bottom: 16px;
    `)};
  }
`;

const logoAndPointLineImage = styled.div`
  position: absolute;
  top: 0;
  left: calc(50% - 36px);
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mobile(css`
    width: 64px;
    flex: 0 0 64px;
    position: static;
    top: auto;
    left: auto;
  `)};

  > .image-history-point-line {
    margin-top: -1px;
  }
`;

const historyContainer = styled.div`
  position: relative;
  display: flex;
  gap: 45px;
  width: 1126px;
  height: 531px;

  ${mobile(css`
    width: 100%;
    height: auto;
    gap: 0;
  `)};
`;

const historyList = styled.ul<{ layout: "left" | "right" | "mobile" }>`
  position: absolute;
  top: 92px;

  ${({ layout }) => {
    if (layout === "left")
      return css`
        right: calc(50% + 23.5px);
        text-align: right;
      `;

    return css`
      left: calc(50% + 23.5px);
    `;
  }};

  ${mobile(css`
    position: static;
    margin-top: 86px;
    margin-left: -12.5px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  `)};
`;

const historyItem = styled.li<{ top?: string }>`
  margin-top: ${({ top }) => top ?? "0px"};
  ${setFontStyle("Body3")};
  color: ${TEXT_COLOR.black_3};
  animation-delay: 0.1s;

  ${mobile(css<{ top?: string }>`
    margin-top: 0;
    position: absolute;
    top: ${({ top }) => top ?? "0px"};
  `)};

  > * {
    display: block;
  }

  > strong {
    ${setFontStyle("SubHead2")};
    color: ${TEXT_COLOR.black_2};
    margin-bottom: 4px;
  }
`;

export default {
  containerWrapper,
  container,
  logoAndPointLineImage,
  historyContainer,
  historyList,
  historyItem,
};
